"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
const Endpoint_1 = require("../common/Endpoint");
const ClientEndpoint_1 = require("./ClientEndpoint");
exports.createClient = (api, options) => {
    const recursiveInitialize = (api, pathContext = "") => {
        const res = {};
        Object.entries(api).forEach(([key, value]) => {
            if (value instanceof Endpoint_1.PublicEndpoint) {
                res[key] = new ClientEndpoint_1.PublicClientEndpoint(value, options, `${pathContext}/${key}`);
            }
            else if (value instanceof Endpoint_1.AuthenticatedEndpoint) {
                res[key] = new ClientEndpoint_1.AuthenticatedClientEndpoint(value, options, `${pathContext}/${key}`);
            }
            else {
                res[key] = recursiveInitialize(value, `${pathContext}/${key}`);
            }
        });
        return res;
    };
    return recursiveInitialize(api);
};
//# sourceMappingURL=client.js.map